document.addEventListener("DOMContentLoaded", function(){

  heroSlideShowSection();
  imgWithTextSlider();
  productMediaGallery();
  logosSlider();
  gallerySlider();
  planboxSlider();
  iconTextSlider();
  contectInfoSlider();
  
});



// (function () {
//   var viewportWidth = window.innerWidth;
//   if (viewportWidth < 1024) {
    
//     iconTextSlider();
    
//   }  
// }());



function heroSlideShowSection(){
  let heroSlideMedia = document.querySelectorAll('.hero-slideshow-slider [data-slideshow-slider]');
  if(heroSlideMedia.length){

    heroSlideMedia.forEach(slideEle => {
      
      let getSliderOptions = JSON.parse(slideEle.getAttribute('data-slider-options') || '{}');
      let extendFunction = {
        on: {
          transitionStart: function(){
            const allVideos = [...slideEle.querySelectorAll('video, iframe')];
            if(allVideos.length) window.pauseAllMedia();
          },
          
          transitionEnd: function(){
            const activeIndex = this.activeIndex;
            const activeSlide = slideEle.querySelectorAll('.swiper-slide')[activeIndex];
            const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
            if(activeSlideVideo) activeSlideVideo.play();
            //for external video
            const activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
            if(activeSlideIframe){
              let iframeSrc = activeSlideIframe.getAttribute('src');
              if(iframeSrc.includes('?autoplay=0')){
                let newSrc = iframeSrc.replace('?autoplay=0','?autoplay=1&muted=1');
                activeSlideIframe.setAttribute('src',newSrc);
              }
              if(iframeSrc.includes('vimeo.com')){
                activeSlideIframe.contentWindow.postMessage('{"method":"play"}', '*');
              }else{
                activeSlideIframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
              }
            }
          }
        }
      }

      let mergeOptions = Object.assign({}, getSliderOptions, extendFunction);
      
      let sliderInit = new Swiper(slideEle, mergeOptions);
      
    });
  }
}



function productMediaGallery() {

  let pdpMediaSwiper = document.querySelector('[data-media-layout="carousel"] [data-pdp-slider]');

  if(pdpMediaSwiper){

    let pdpMediaSwiperEle = pdpMediaSwiper.querySelector('[data-main-pdp-swiper]');
    let sliderOptions = JSON.parse(pdpMediaSwiper.getAttribute('data-slider-options') || '{}');

    if(!pdpMediaSwiperEle && !Object.keys(sliderOptions).length) return;

    let extendOptions = {
      on: {
        transitionStart: function(){
          const allVideos = [...pdpMediaSwiperEle.querySelectorAll('video, iframe')];
          if(allVideos.length) window.pauseAllMedia();
        },
        
        transitionEnd: function(){
          const activeIndex = this.activeIndex;
          const activeSlide = pdpMediaSwiperEle.querySelectorAll('.swiper-slide')[activeIndex];
          const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
          if(activeSlideVideo) activeSlideVideo.play();
          //for external video
          const activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
          if(activeSlideIframe){
            let iframeSrc = activeSlideIframe.getAttribute('src');
            if(iframeSrc.includes('?autoplay=0')){
              let newSrc = iframeSrc.replace('?autoplay=0','?autoplay=1&muted=1');
              activeSlideIframe.setAttribute('src',newSrc);
            }
            if(iframeSrc.includes('vimeo.com')){
              activeSlideIframe.contentWindow.postMessage('{"method":"play"}', '*');
            }else{
              activeSlideIframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            }
          }
        }
      }
    }

    let mergeOptions = Object.assign({}, sliderOptions, extendOptions);
    let sliderInit = new Swiper(pdpMediaSwiperEle, mergeOptions);
    
  }
  
}


// faq tabs toggal start
function togal_tabs(item) {
  item.addEventListener("click", () => {
    toggal_all_tabs(item.getAttribute("data-faq_content"));
  });
}
function toggal_all_tabs(tabs_data) {
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach((b) => {
    if (b.getAttribute("data-faq_content") == tabs_data) {
      if (b.classList.contains("is_open")) {
        b.classList.remove("is_open");
      } else {
        b.classList.add("is_open");
      }
    } else {
      b.classList.remove("is_open");
    }
  });
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();

// faq tabs toggal end

// faq tabs toggal content start
function tab_mai_mappert(item) {
  item.addEventListener("click", () => {
    toggal_all_tabs_content(item.getAttribute("data-hendles"));
  });
}
function toggal_all_tabs_content(tabs_data) {
  let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
  tabs_content_toggel.forEach((b) => {
    if (b.getAttribute("data-hendles") == tabs_data) {
      b.classList.add("active");
      document.querySelector(b.getAttribute("data-hendles")).style.display =
        "block";
    } else {
      b.classList.remove("active");
      document.querySelector(b.getAttribute("data-hendles")).style.display =
        "none";
    }
  });
}
let tabs_content = document.querySelectorAll("[data-hendles]");
tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end

// Add this code make menu appears image hover
function bindMouseOverToMegaMenu_images(item) {
  item.addEventListener("mouseover", () => {
    image_hide(item.getAttribute("data-image-name"));
    let image = document
      .querySelector(".header__inline-menu")
      .querySelector("img.col_image");
    item.addEventListener("mouseleave", () => {
      image_hide();
    });
  });
}
function image_hide(imag) {
  let images_val = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("img.col_image");
  images_val.forEach((b) => {
    if (b.alt == imag) {
      b.classList.remove("hidden");
    } else {
      b.classList.add("hidden");
    }
  });
}
let main_images = document.querySelector(".header__inline-menu");
if (main_images) {
  let images = main_images.querySelectorAll("[data-image-name]");
  images.forEach(bindMouseOverToMegaMenu_images);
}


function logosSlider() {
  var swiper = new Swiper(".logosSlider", {    
      slidesPerView: 2,
      spaceBetween: 20,
      init: true,
      loop: true,
      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: ".logosSlider_next",
        prevEl: ".logosSlider_prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
      },  
  });
}


function iconTextSlider() {
  var swiper = new Swiper(".iconTextSlider", {    
    slidesPerView: 1,
      spaceBetween: 5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
         1100: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      },  
  });
}

function contectInfoSlider() {
  var swiper = new Swiper(".contectInfoSlider", {    
    slidesPerView: 1,
      spaceBetween: 5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        400: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
         1100: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },  
  });
}


function gallerySlider() { 
  if(!document.querySelector('.gallery-slider-wrapper .gallery-slider-list')) return;  
  var swiper = new Swiper(".gallery-slider-list", {
    spaceBetween: 10,        
    draggable: false,
    keyboard: {
      enabled: true,
    },
    // scrollbar: {
    //   el: ".swiper-scrollbar",
    //   hide: false,
    //   draggable: true,
    // },
    autoplay: {
      delay: 4000,
    },
    loop: true,
    slidesPerView:'auto',
    initialSlide: 1,
    allowTouchMove: false,
    // disableOnInteraction: true
  });    
}


function planboxSlider() {
  var swiper = new Swiper(".planboxSlider", {    
      slidesPerView: 1,
      spaceBetween: 20,
      initialSlide: 1,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 0,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
          initialSlide: 0,
        },
      },  
  });
}


function imgWithTextSlider() {
   var swiper = new Swiper(".imgWithTextSlider", {      
      slidesPerView: 1,
      loop: true,
      spaceBetween: 10,
      direction: 'horizontal',  
      navigation: {
        nextEl: ".imgWithText_next",
        prevEl: ".imgWithText_prev",
      },
     breakpoints: {
        750: {
          slidesPerView: "auto",     
          spaceBetween: 15,
          direction: 'vertical',   
          freeMode: true,
        },
      },
    });
}


// function setSlideHeight(el){
//     $('.imgWithTextSlider .swiper-slide').css({height:'auto'});
//     var currentSlide = el.activeIndex;
//     var newHeight = $(el.slides[currentSlide]).height();

//     $('.imgWithTextSlider .swiper-wrapper, .imgWithTextSlider .swiper-slide').css({ height : newHeight })
//     el.update();
// }





// START template -- product [ PRODUCT ]
    if (document.body.classList.contains("template-product")) {
      initPDP_accordion();
    }
// END template -- product [ PRODUCT ]

function initPDP_accordion(){
  var pdpAccordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    var links = this.el.find('.js-acc-single-trigger');
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
  // $(".accordion-single-item:first-of-type").addClass("open");
  pdpAccordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
      $this = $(this),
      $next = $this.next();
    $next.slideToggle();
    $this.parent().toggleClass('open');
    if (!e.data.multiple) {
      $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var pdpAccordion1 = new pdpAccordion($('#pdp_accordion'), false);
}

//-------- product page products dropdown
var dropBtn = document.querySelector('.drop_btn');
if(dropBtn){
  dropBtn.addEventListener('click', function() {
      var dropdown = this.closest('.dropdown_products_main');
      if (dropdown) { dropdown.classList.toggle('active'); }
  });
}

document.addEventListener('click', function(event) {
    if (!event.target.closest('.dropdown_products_main')) {
      var drop_main = document.querySelector('.dropdown_products_main'); 
      if(drop_main){drop_main.classList.remove('active')}
    }
});

//------------ Back to top Button
function back_to_top() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

var address_phoneNew = document.getElementById('AddressPhoneNew');
if(address_phoneNew){
   address_phoneNew.addEventListener('input', function() {
      if (this.value.length > 12) {
          this.value = this.value.slice(0, 12);
      }
    }); 
}

//-------------- Account Register
var first_name = document.getElementById('RegisterForm-FirstName'); 
if(first_name){
   first_name.addEventListener('input', function() {
      var sanitizedValue = this.value.replace(/\d/g, '');
      if (this.value !== sanitizedValue) { this.value = sanitizedValue; }
   }); 
}

var last_name = document.getElementById('RegisterForm-LastName'); 
if(last_name){
   last_name.addEventListener('input', function() {
      var sanitizedValue = this.value.replace(/\d/g, '');
      if (this.value !== sanitizedValue) { this.value = sanitizedValue; }
  });  
}

//----------- SlideShow Video

document.addEventListener('DOMContentLoaded', function() {
  var slideshow_videos = document.getElementsByClassName('slideshow_video');
  Array.prototype.forEach.call(slideshow_videos, function(video) {
      video.addEventListener('canplaythrough', function() {
          video.play();
      });
      video.addEventListener('loadedmetadata', function() {
          video.play();
      });
  });
});




// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END




if(document.body.classList.contains('template-index')){
var isALARendered;
function ALAcheck() {
 isALARendered = setInterval(function () {
 customALA()
 }, 2000);
}
ALAcheck();
  function customALA() {
    var custom_app_code = document.querySelectorAll('[data-id]') || null;
    if(custom_app_code.length > 0) {
       var data_text = document.querySelector('[data-title-main]') || null;
      if(data_text){
        var maintext= data_text.getAttribute('data-title-main');
         clearInterval(isALARendered);
              custom_app_code.forEach((b) => {
                var title = b.textContent.replaceAll(" ", '-');
                title = title.toLowerCase()
                console.log(title == maintext);
                  if (title == maintext) {
                    var button = document.querySelector('.step1 button.continue-button.c1') || null;
                      b.click();
                    if(button){
                      button.removeAttribute('disabled');
                      button.click();
                    }
                  }
                });
        }
    }
  }
}
// This will only render in the theme editor
if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){

      const mainPDPSection = event.target.closest('.main-product') || null;
      if(mainPDPSection){
        productMediaGallery();
      }
      
      const swiperSlideShowSection = event.target.closest('.hero-slideshow-slider') || null;
      if(swiperSlideShowSection){
        heroSlideShowSection();
      }
      
      const imgTextSliderSectionDM = event.target.closest('.image-text-and-slider') || null;
      if(imgTextSliderSectionDM){
        imgTextSliderSection();
      }

      const logosSliderDM = event.target.closest('.brand-logos-wrapper') || null;
      if(logosSliderDM){
        logosSlider();
      }

      const iconTextSliderDM = event.target.closest('.icon-with-text-wrapper') || null;
      if(iconTextSliderDM){
        iconTextSlider();
      } 

       const contectInfoSliderDM = event.target.closest('.contact-info-wrapper') || null;
      if(contectInfoSliderDM){
        contectInfoSlider();
      } 

     const gallerySliderWrapper = event.target.closest('.text-with-slider-wrapper') || null;
      if(gallerySliderWrapper){
        gallerySlider();
      }   
      
      
    });
  });
}